<template>
  <div class="company-detail-base">
    <div class="base-item">
      <img v-if="partnerLogo" style="border-radius: 16px;width: auto;height: 80px;margin-top: 24px;" :src="partnerLogo" alt="" />
      <div class="title">{{$t('crm_renter_detail_base.ji_chu_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_ming_cheng')}}</div>
          <div class="val">{{ data.partnerName }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_lei_xing')}}</div>
          <div class="val">{{ getDicValue('bas_org_type', data.partnerType) }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_dian_hua')}}</div>
          <div class="val">{{ data.telephone }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_you_xiang')}}</div>
          <div class="val">{{ data.email }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_wang_zhi')}}</div>
          <div class="val">{{ data.website }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.tyshxydmyyzzbh')}}</div>
          <div class="val">{{ data.businessLicense }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.nsrsbhswdjbh')}}</div>
          <div class="val">{{ data.buyerNumber }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.ren_zheng_zhuang_tai')}}</div>
          <div class="val">{{getDicValue('real_auth_status',data.realNameState)}}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.ying_ye_zhi_zhao')}}</div>
          <div class="val">
            <span class="detail" @click="visible = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_gui_mo')}}</div>
          <div class="val">{{getDicValue('crm_partner_scale',data.partnerScale)}}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.zhu_ce_zi_jin')}}</div>
          <div class="val">
            {{ data.currencyUnit }}{{ data.registeredCapital }}
          </div>
        </div>
        <div class="col" v-if="data.timeZoneDto&&timeZoneCountOverOne">
          <div class="key">
            {{ $t('crm_renter_detail_base.shi_qu') }}
          </div>
          <div class="val">
            {{ `(${data.timeZoneDto.utcZoneName})` }} {{ data.timeZoneDto.timeZoneRegion }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col long">
          <div class="key">{{$t('crm_renter_detail_base.gong_si_di_zhi')}}</div>
          <div class="val">{{ [data.country, data.province, data.city].join("")
            }}{{ data.detailAddress }}</div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_renter_detail_base.fa_ren_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.fa_ren_xing_ming')}}</div>
          <div class="val">{{ data.legalPerson }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.frsfzh')}}</div>
          <div class="val">{{ data.legalPersonIdentity }}</div>
        </div>

        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.zheng_jian_zhao')}}</div>
          <div class="val">
            <span class="detail" @click="visible2 = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_renter_detail_base.dgzhxx')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.dui_gong_zhang_hao')}}</div>
          <div class="val">{{ data.depositNumber }}</div>
        </div>
        <!-- <div class="col">
          <div class="key">{{$t('开户行','label_bankCode')}}</div>
          <div class="val">
            {{ data.bankName }}
          </div>
        </div> -->
        <div class="col">
          <div class="key">{{$t('crm_renter_detail_base.kai_hu_yin_hang')}}</div>
          <div class="val">{{ data.depositBank }}</div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_renter_detail_base.guan_li_yuan_xin_xi')}}</div>
      <div class="table-bd">
        <custom-table
          :data="tableList"
          :column="tableColumn"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
    </div>
    <img-detail-dialog
      :bizData="idPhotoData"
      :title="$t('crm_renter_detail_base.zheng_jian_zhao')"
      v-if="visible2"
      @close="visible2 = false"
    ></img-detail-dialog>
    <img-detail-dialog
      :bizData="licenseData"
      :title="$t('crm_renter_detail_base.ying_ye_zhi_zhao')"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String
  },
  computed: {
    // 证件照biz数据
    idPhotoData() {
      return [
        // 身份证人像面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.face'
        },
        // 身份证国徽面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.reverse'
        }
      ];
    },
    // 营业执照biz数据
    licenseData() {
      return [
        {
          bizId: this.partnerId,
          bizType: 'crm.partner.license'
        }
      ];
    },
    timeZoneCountOverOne() {
      return this.$store.state.timeZoneCount > 1;
    },
  },
  watch: {
    'data.partnerOrgId': {
      immediate: true,
      handler(val) {
        if (val) {
          this.getTableList();
          this.getLogo();
        }
      },
    },
  },
  data() {
    return {
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      tableCode: 'company_admin_info',
      tableList: [],
      partnerLogo: null
    };
  },
  methods: {
    // 获取图片列表
    getLogo() {
      this.$getFileList({ bizId: this.data.partnerOrgId, bizType: 'crm.partner.logo' }).then((list) => {
        this.partnerLogo = list.length > 0 ? list[0].attachPath : null;
      });
    },
    getTableList() {
      this.$getJSON(`${apis.partnerOrganAdminItem}/${this.data.partnerOrgId}`).then(
        (res) => {
          this.tableList = [res.data];
        }
      );
    }
  },
  mounted() {
    this.getTableColumn();
  }
};
</script>

<style lang="scss" scoped>
.company-detail-base {
  padding-left: 40px;
  padding-right: 24px;
  .base-item {
    font-size: 12px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eef2f8;

    &:nth-child(n + 2) {
      margin-top: 7px;
    }

    overflow: hidden;
    .title {
      color: #0d9ae0;
      font-weight: bold;
      line-height: 16px;
      margin-top: 24px;
    }
    .row {
      overflow: hidden;
      .col {
        float: left;
        width: 250px;
        margin-top: 24px;
        &.long {
          width: 100%;
        }
        .key {
          color: #98a6ad;
          line-height: 16px;
        }
        .val {
          margin-top: 8px;
          font-weight: bold;
          color: #495057;
        }
        .detail {
          color: #0d9ae0;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .table-bd {
      margin-top: 24px;
    }
  }
}
</style>
